import React, { lazy, useRef, useState, useEffect, startTransition } from 'react'
import { useIsVisible } from 'react-is-visible'
import { pageStore } from "state/store-zustand"

import dayjs from "dayjs"

import Icon from 'components/elements/icon'
import SVG from 'react-inlinesvg'

import Skeleton from "react-loading-skeleton"

const BasicMap = React.lazy(() => import('components/map/basicMap'))
import DateToCalendar from 'components/shared/dateToCalendar'
const Hours = lazy(() => import("templates/place/hours"))

import { LogisticDropdown } from "./reservationLinks"


const TimeLocation = ({
  showOnLoad = true,
  ...props
}) => {
  const ref = useRef()
  const mapRef = useRef()
  const isVisible = useIsVisible(ref)

  // FIXME: Move this to the backend
  const ensureInstagramUrl = (url) => {
    if (!url || url === 'https://instagram.com/' || url === 'https://www.instagram.com/') {
      return null; // Return null for empty or incomplete Instagram URLs
    }

    // Prepend the base URL if it's not already a valid Instagram URL
    return url.startsWith('https://instagram.com/') || url.startsWith('https://www.instagram.com/')
      ? url
      : `https://instagram.com/${url}`;
  };

  const pathFromURL = (url) => {
    const urlWithoutSlash = url.replace(/\/$/, '')
    const urlArray = urlWithoutSlash.split('/')
    const handle = urlArray[urlArray.length - 1]

    return handle
  }

  const {
    details,
    buttonAction = 'visit',
    placeType = 'event' } = props

  const isDesktop = pageStore((state) => state.isDesktop)
  const isMobile = pageStore((state) => state.isMobile)
  const isTablet = pageStore((state) => state.isTablet)

  const {
    id,
    properties,
    title
  } = details || {}

  const {
    address,
    categories,
    description,
    event_categories,
    facebook,
    instagram,
    yelp,
    twitter,
    hotspots_place,
    is_free,
    is_open_24hrs,
    location,
    opening_hours,
    start_date,
    end_date,
    links,
    likes,
    rating,
    price,
    telephone,
    vibemap_images,
    url
  } = properties || details // Safely unwrap properties from place or place.properties

  // FIXME: Only mark as free if is_free is true
  const isFree = price && typeof price == "string" && price.toUpperCase() === ''

  const isClosedEveryday = opening_hours?.every(
    ({ opens, closes }) => opens === "00:00:00" && closes === "00:00:00"
  )

  const getCategory = () => {
    const period = price ? " - " : ""

    if (categories?.length > 0) return categories[0] + period
    if (event_categories?.length > 0) return event_categories[0] + period

    return null
  }

  const getPriceLevel = price => {
    let level = "$".repeat(+price)
    if (!level) return ""
    return level
  }

  const labels = {
    'book-now': 'Book Now'
  }

  const buttonLabel = (action) => {
    switch (action) {
      case 'book-now':
        return 'Book Now'
      case 'visit':
        return 'Plan your Visit'
      default:
        return 'More Info'
    }
  }

  const height = isDesktop || isTablet
    ? 300
    : 240

  const width = `100%`

  const venue = hotspots_place?.properties?.name

  const place = hotspots_place
    ? hotspots_place
    : details

  const timezone = hotspots_place?.properties?.timezone || 'America/New_York'

  const latitude = place?.geometry?.coordinates[1]
  const longitude = place?.geometry?.coordinates[0]

  let DetailsMap;
  startTransition(() => {
    DetailsMap = place?.geometry
      ? <div className='map'>
        <React.Suspense fallback={
          <Skeleton height="100%" width="100%">
            <div>Finding vibes near you...</div>
          </Skeleton>
        }>
          <BasicMap
            mapRef={mapRef}
            latitude={latitude}
            longitude={longitude}
            height={height}
            width={width}
            dragPan={false}
            showFullScreen={false}
            showExplore={false}
            showPlaces={false}
            showDraggableMarker={false}
            showFeaturedMarker={true}
            map3d={false}
            scrollZoom={false}
            zoom={15.5} />
        </React.Suspense>
      </div>
      : null;
  });


  const PlaceOpenOrClose = () => {
    const { startDate, endDate } = props

    const startTime = dayjs(startDate).format("h:mma")
    const endTime = dayjs(endDate).format("h:mma")

    if (!!details?.is_closed) {
      return (
        <div>
          <span className={"close"}>Closed</span>
          <span className="closes_at">
            {" "}
            <span>&#183;</span> Opens By {startTime}
          </span>
        </div>
      )
    }

    return (
      <div>
        <span className={"open"}>Open</span>
        <span className="closes_at">
          {" "}
          <span>&#183;</span> Closes By {endTime}{" "}
        </span>
      </div>
    )
  }

  const ticketPrice = <span>{`${(isFree || price == null) ? ' ' : ' $'}${price ? price.toFixed(2) : ''}`}</span>

  const priceLevel = <span>{price == '4'
    ? '$$$$'
    : price == '3'
      ? '$$$'
      : price == '2'
        ? '$$'
        : '$'
  }</span>

  const rowStyle = {
    display: 'flex',
    marginBottom: `1.2rem`
  }

  const iconStyle = {
    "fill-opacity": 1,
    width: '20px',
    height: '20px',
    marginRight: '8px'
  }

  const ticketButton = (
    <div className='ticket'>
      <a href={url} className='ui button small secondary fluid'>
        {buttonLabel(buttonAction)}
      </a>
    </div>
  )

  const category = getCategory()

  return (
    <div ref={ref} className='location-details'>
      <h4>Plan Your Visit</h4>

      {category
        ? <p className='category'>{`${category ? category : ''}`}</p>
        : null
      }

      <div className="map-container">
        {isClosedEveryday != true
          ? <React.Suspense fallback={null}>
              <Hours hours={opening_hours} />
            </React.Suspense>
          : null
        }

        {is_open_24hrs == true
          ? <div className="section">
            <p>Open 24 hours a day.</p>
          </div>
          : null
        }

        <LogisticDropdown
          data={links}
          show={true}
        //onToggle={handleToggleReservation}
        />


        {likes &&
          <p>{`${likes} people like this`}</p>
        }
        {start_date &&
          <DateToCalendar
            address={address}
            start_date={start_date}
            end_date={end_date}
            name={title}
            description={description}
            timezone={timezone} />
        }
        <>
          {url &&
            <p style={rowStyle}>
              <Icon type='web' />
              <a href={url}>Website</a>
            </p>
          }
          {telephone &&
            <p style={rowStyle}>
              <Icon type='phone' />
              <span>{telephone}</span>
            </p>
          }

          {instagram
            ? <p style={rowStyle}>
              <a
                href={ensureInstagramUrl(props?.details?.instagram)}
                target="_blank"
                rel="noopener noreferrer"
                style={rowStyle}>
                <span class="icon instagram">
                  <SVG
                    className={'icon instagram'}
                    fill={'#000000'}
                    src={"/svgs/instagram.svg"}
                    style={iconStyle}
                  />
                </span>
                <span>
                  {pathFromURL(instagram)}
                </span>
              </a>
            </p>
            : null
          }

          {facebook
            ? <p style={rowStyle}>
              <a href={props?.details?.facebook}>
                <SVG
                  className={'icon facebook'}
                  src={"/svgs/facebook.svg"}
                  style={iconStyle}
                />

                <span>{pathFromURL(facebook)}</span>
              </a>
            </p>
            : null
          }

          {twitter
            ? <p className='social-row' style={rowStyle}>
              <a href={props?.details?.twitter} style={rowStyle}>
                <SVG
                  className={'icon facebook'}
                  src={"/svgs/twitter.svg"}
                  style={iconStyle}
                />
                {pathFromURL(twitter)}
              </a>
            </p>
            : null
          }

          {price &&
            <p className='price' style={rowStyle}>
              <Icon type='price' />
              <span>Price range: </span>
              <span className='amount'>
                {placeType == 'event'
                  ? ticketPrice
                  : priceLevel
                }
              </span>
            </p>
          }
        </>

        {DetailsMap}

        <p style={{ paddingTop: '1em' }}>
          <Icon type='map' />
          <span>{address ? address : place?.properties?.address}</span>
        </p>
        {venue &&
          <p>
            <Icon type='map' />
            <span>{venue}</span>
          </p>
        }
        {ticketButton}
      </div>
    </div>
  )
}

export default TimeLocation
